import { render, staticRenderFns } from "./ParticipantItems.vue?vue&type=template&id=7a82353a&scoped=true"
import script from "./ParticipantItems.vue?vue&type=script&lang=js"
export * from "./ParticipantItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a82353a",
  null
  
)

export default component.exports